import React, { useEffect, useState } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useLocation } from 'react-router';
import { Box, Stack, Typography } from '@mui/material';
import rehypeRaw from 'rehype-raw';
import { fileIndex } from '../../utils/fileIndex';
export default function Md() {
    const location = useLocation();
    const filepath = location.pathname.replace('/md/', '');
    const [metadata, setMetadata] = useState({});

    const [content, setContent] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchMarkdown() {
            try {
                const response = await fetch(`/${filepath}`);
                // Detect if the file actually exists
                if (!response.ok) {
                    throw new Error(`Failed to fetch ${filepath}: ${response.statusText}`);
                }
                // Check if we accidentally got index.html instead of a markdown file
                const text = await response.text();
                if (text.startsWith('<!DOCTYPE html>')) {
                    throw new Error(`File ${filepath} does not exist.`);
                }
                setContent(text);
            } catch (err) {
                setError(err.message);
            }
        }

        fetchMarkdown();

        const metadata = fileIndex.find(item => {
            const itemPath = item.link.replace('/md/', '');
            return itemPath === filepath; // exact match
        });

        setMetadata(metadata);
    }, [filepath]);

    if (error) {return <div style={{ color: 'red' }}>Error: {error}</div>;}
    if (!content) {return <div>Loading...</div>;}

    return (
        <Stack
            sx={{
                m: 10,
                mx: 30
            }}
        >
            {metadata.name && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end'
                    }}
                >
                    <Stack direction="row" spacing={2} alignItems="ri">
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Box
                                sx={{
                                    width: 12,
                                    height: 12,
                                    borderRadius: '50%',
                                    bgcolor: metadata.color || 'rgba(0,0,0,0)' // fallback color
                                }}
                            />
                            <Typography color="#8c929b" fontSize={12} fontFamily="inherit">
                                {metadata.language || ''}
                            </Typography>
                        </Stack>
                        <Typography color="#8c929b" fontSize={12} fontFamily="inherit">
                            {metadata.updated || ''}
                        </Typography>
                    </Stack>
                </Box>
            )}

            <Box
                className="markdown-body"
                sx={{
                    my: 1,
                    p: 5,
                    border: '1px solid',
                    borderColor: 'gray',
                    borderRadius: '4px'
                }}
            >
                <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                    {content}
                </Markdown>
            </Box>
        </Stack>
    );

}